export default {"src":"/_next/static/media/ActiveCheckmarkDark.ec58bcc6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};